import React from 'react';

import PropTypes from 'prop-types';

import TableReceivedApplications from 'components/TableReceivedApplications';

export default function ApplicationsUnderStudy({ data, reloadData }) {
  return (
    <div>
      <h4>
        Postulaciones en estudio
      </h4>
      <p>
        Aquí se muestran las postulaciones que fueron descargadas y están en proceso de estudio.
      </p>
      <TableReceivedApplications data={data} type="ApplicationsUnderStudy" reloadData={reloadData} />
    </div>
  );
}

ApplicationsUnderStudy.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  reloadData: PropTypes.func,
}.isRequired;
